
import { useState } from 'react';
import { FormData } from '@/types/form';
import { useToast } from '@/hooks/use-toast';
import i18n from '@/i18n';

interface FormElement {
  name?: string;
  label?: string;
  required?: boolean;
}

export const useFormValidation = () => {
  const [validationErrors, setValidationErrors] = useState<string[]>([]);
  const { toast } = useToast();
  
  const validateRequiredFields = (elements: FormElement[], formData: FormData): boolean => {
    const requiredFields = elements
      .filter(element => element.required)
      .map(element => ({
        name: element.name,
        label: element.label || element.name
      }));
    
    const missingFields = requiredFields.filter(field => {
      if (!field.name) return false;
      
      const value = formData[field.name];
      
      if (value === undefined || value === null || value === '') {
        return true;
      }
      
      if (Array.isArray(value) && value.length === 0) {
        return true;
      }
      
      if (typeof value === 'boolean' && !value) {
        return true;
      }
      
      return false;
    });
    
    if (missingFields.length > 0) {
      const errorMessages = missingFields.map(field => 
        i18n.t('form.validationFieldMissing', { label: field.label })
      );
      setValidationErrors(errorMessages);
      return false;
    }
    
    setValidationErrors([]);
    return true;
  };
  
  const showValidationErrorToast = () => {
    toast({
      title: i18n.t('form.validationToastTitle'),
      description: i18n.t('form.validationToastDesc'),
      variant: "destructive",
    });
  };

  return {
    validationErrors,
    validateRequiredFields,
    showValidationErrorToast
  };
};
